/**
 * @file Admin dashboard UI — pages/Dashboard/Admin/Form/AddSubSectionModal.tsx.
 */

// src/pages/Admin/Form/AddSubSectionModal.tsx
import React, { useState } from "react";

interface Props {
  sectionId: number;
  onClose: () => void;
  onSave: (data: {
    name: string;
    code: string;
    description?: string;
    order?: number;
    formSectionId: number;
  }) => void;
}

const AddSubSectionModal: React.FC<Props> = ({
  sectionId,
  onClose,
  onSave,
}) => {
  const [form, setForm] = useState({
    name: "",
    code: "",
    description: "",
    order: 1,
  });

  const handleSave = () => {
    if (!form.name || !form.code) {
      alert("Please fill in both name and code.");
      return;
    }
    onSave({ ...form, formSectionId: sectionId });
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h3>Add New Subsection</h3>

        <input
          placeholder="Subsection Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />

        <input
          placeholder="Subsection Code"
          value={form.code}
          onChange={(e) => setForm({ ...form, code: e.target.value })}
        />

        <textarea
          placeholder="Description"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
        />

        <input
          type="number"
          placeholder="Order"
          value={form.order}
          onChange={(e) => setForm({ ...form, order: Number(e.target.value) })}
        />

        <div className="modal-actions">
          <button onClick={handleSave}>Save</button>
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

/** React component — Add Sub Section Modal. */
export default AddSubSectionModal;
